import { Component } from '@angular/core';
import { NavigationStart, Router, Event as RouterEvent, } from '@angular/router';
import { setTheme } from 'ngx-bootstrap/utils';
import { CommonService } from './shared/common/common.service';
import { url } from './shared/models/Data.model';
import { Title } from '@angular/platform-browser';
import { environment } from './environment/environment';
import { SettingService } from './shared/settings/settings.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Vibgyor';
  base = '';
  page = '';
  last = '';
  constructor(
    private common: CommonService,
    private router: Router,
    private settingsService: SettingService,
    private titleService: Title
  ) {
    setTheme('bs5');
    this.titleService.setTitle(environment.customerName + ' - ' + environment.productName);
    this.settingsService.setFavicon(environment.faviconPath);
    this.common.base.subscribe((res: string) => {
      this.base = res;
    });
    this.common.page.subscribe((res: string) => {
      this.page = res;
    });
    this.common.last.subscribe((res: string) => {
      this.last = res;
    });
    this.router.events.subscribe((data: RouterEvent) => {
      if (data instanceof NavigationStart) {
        this.getRoutes(data);
      }
    });
  }
  public getRoutes(events: url) {
    const splitVal = events.url.split('/');
    this.common.base.next(splitVal[1]);
    this.common.page.next(splitVal[2]);
    this.common.last.next(splitVal[3]);
  }
}
